import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b385e19e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-page" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "user-details" }
const _hoisted_5 = {
  key: 0,
  class: "badge"
}
const _hoisted_6 = { class: "user-detail" }
const _hoisted_7 = { class: "user-detail" }
const _hoisted_8 = { class: "contact-info" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "page-actions" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-pills" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        id: "aboutTab",
        class: "nav-link active",
        "data-bs-toggle": "tab",
        "data-bs-target": "#aboutPane",
        role: "tab",
        "aria-controls": "aboutPane",
        "aria-selected": "false"
      }, " About ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        id: "researchGroupsTab",
        class: "nav-link",
        "data-bs-toggle": "tab",
        "data-bs-target": "#researchGroupsPane",
        role: "tab",
        "aria-controls": "researchGroupsPane",
        "aria-selected": "true"
      }, " Trees ")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        id: "familyGroupsTab",
        class: "nav-link",
        "data-bs-toggle": "tab",
        "data-bs-target": "#familyGroupsPane",
        role: "tab",
        "aria-controls": "familyGroupsPane",
        "aria-selected": "true"
      }, " Groups ")
    ])
  ])
], -1))
const _hoisted_17 = { class: "tab-content content-area" }
const _hoisted_18 = {
  id: "aboutPane",
  class: "tab-pane show active",
  role: "tabpanel",
  "aria-labelledby": "aboutTab",
  tabindex: "0"
}
const _hoisted_19 = {
  id: "researchGroupsPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "researchGroupsTab",
  tabindex: "0"
}
const _hoisted_20 = {
  id: "familyGroupsPane",
  class: "tab-pane",
  role: "tabpanel",
  "aria-labelledby": "familyGroupsTab",
  tabindex: "0"
}

import { ref, computed, watch } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { useInitialTabRouting } from '@/util/InitialTabRouting'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { DataGroup, ItemPermissions, PrivacyLevel, socialAccountProviders } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { useTokenManager, UserPrivilege } from '@/auth/TokenManager'
import { CalendarIcon, MailIcon, MapPinIcon, PhoneIcon, ShieldIcon } from '@zhuowenli/vue-feather-icons'
import FamilyGroupList from '@/manage/familygroups/FamilyGroupList.vue'
import ResearchGroupList from '@/manage/researchgroups/ResearchGroupList.vue'
import UserProfileContent from '@/manage/users/UserProfileContent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfilePage',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;



const isUserProfileVisibleRef = ref(false)
const userProfileGroupRef = ref<DataGroup>()
const userPersonIdRef = ref<string>()
const userPrivilegesRef = ref<UserPrivilege[]>()

const userStore = useUserStore()
const viewPersonStore = useViewPersonStore()
const dataGroupStore = useDataGroupStore()
const personStore = usePersonStore()
const tokenManager = useTokenManager()

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId!)
const isSelfRef = computed(() => userIdRef.value == tokenManager.current.userId)
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const permissionsRef = computed(() => userStore.getAsyncPermissions(userIdRef.value, LoadMode.EnsureLoaded)?.data)
const canManageUsersRef = computed(() => tokenManager.current.hasPrivilege(UserPrivilege.ManageUsers))
const isUserAdminRef = computed(() => canManageUsersRef.value || (permissionsRef.value && (permissionsRef.value & ItemPermissions.Modify) > 0))
const isDemoUserRef = computed(() => userPrivilegesRef.value?.includes(UserPrivilege.DemoUser))

const userImageRef = computed(() => userRef.value?.photoUrl ?? new URL('@/assets/icons/person_gray_150.png', import.meta.url).href)
const userLocationRef = computed(() => userRef.value?.metadata?.location)
const countryCodeRef = computed(() => userRef.value?.metadata?.countryCode)
const flagClassRef = computed(() => countryCodeRef.value ? `fi fi-${countryCodeRef.value?.toLowerCase()}` : undefined)
const userCreatedDateRef = computed(() => userRef.value?.createdDate?.toFormat('MMMM yyyy'))
const showEmailRef = computed(() => userRef.value?.email && userRef.value?.emailPrivacy != PrivacyLevel.Me)
const showPhoneRef = computed(() => userRef.value?.mobileNumber && userRef.value?.mobileNumberPrivacy != PrivacyLevel.Me)
const showImpersonateRef = computed(() => !isSelfRef.value && tokenManager.canImpersonateAnyUser())

const title = usePageTitle(() => isSelfRef.value ? "My account" : "User", () => isSelfRef.value ? undefined : userRef.value?.displayName, true)
useInitialTabRouting('aboutTab')

function getSocialLinkFor(providerId: string) {
  return userRef.value?.metadata?.getSocialAccountUrlFor(providerId)
}

watch(userRef, async () => {
  isUserProfileVisibleRef.value = false
  userProfileGroupRef.value = undefined
  userPersonIdRef.value = undefined
  userPrivilegesRef.value = undefined

  if (userRef.value) {
    if (tokenManager.current.hasPrivilege(UserPrivilege.ReadAllDataGroups)) {
      isUserProfileVisibleRef.value = true      
    }
    else {
      const selfViewGroups = await dataGroupStore.getViewGroupsForUserAsync()
      isUserProfileVisibleRef.value = selfViewGroups.some(g => g.id == userRef.value?.profileDataGroupId)
    }

    userPrivilegesRef.value = isSelfRef.value
      ? tokenManager.current.userPrivileges
      : tokenManager.current.hasPrivilege(UserPrivilege.ReadAllUsers) ? await userStore.getPrivilegesAsync(userIdRef.value) : [UserPrivilege.User]

    if (isUserProfileVisibleRef.value) {
      userProfileGroupRef.value = await dataGroupStore.getAsyncGroup(userRef.value.profileDataGroupId, LoadMode.EnsureLoaded)!.whenLoadCompleted
      userPersonIdRef.value = userProfileGroupRef.value?.startItemId

      if (userProfileGroupRef.value) {        
        const vp = await viewPersonStore.getAsyncPerson(userPersonIdRef.value, LoadMode.EnsureLoaded)!.whenLoadCompleted
        await Promise.all([
          personStore.getPersonListAsync(vp?.matchIds ?? []),
          dataGroupStore.getGroupListAsync(vp?.groupIds ?? []),
        ])
      }
    }
  }
}, { immediate: true })

function impersonate() {
  if (props.userId) {
    tokenManager.impersonateAsync(props.userId)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: userImageRef.value }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, [
          _createTextVNode(_toDisplayString(userRef.value?.displayName) + " ", 1),
          (isDemoUserRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " DEMO "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (countryCodeRef.value)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(flagClassRef.value)
              }, null, 2))
            : (_openBlock(), _createBlock(_unref(MapPinIcon), { key: 1 })),
          _createElementVNode("div", null, _toDisplayString(userLocationRef.value), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(CalendarIcon), { size: "1.2x" }),
          _createTextVNode("Joined " + _toDisplayString(userCreatedDateRef.value), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (getSocialLinkFor('x'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: getSocialLinkFor('x'),
                class: "social-link"
              }, [
                _createElementVNode("img", {
                  src: _unref(socialAccountProviders).find(p => p.id == 'x')?.icon
                }, null, 8, _hoisted_10)
              ], 8, _hoisted_9))
            : _createCommentVNode("", true),
          (getSocialLinkFor('facebook'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: getSocialLinkFor('facebook'),
                class: "social-link"
              }, [
                _createElementVNode("img", {
                  src: _unref(socialAccountProviders).find(p => p.id == 'facebook')?.icon
                }, null, 8, _hoisted_12)
              ], 8, _hoisted_11))
            : _createCommentVNode("", true),
          (showEmailRef.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: `mailto:${userRef.value?.email}`,
                class: "social-link"
              }, [
                _createVNode(_unref(MailIcon), { size: "1x" })
              ], 8, _hoisted_13))
            : _createCommentVNode("", true),
          (showPhoneRef.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: `tel:${userRef.value?.mobileNumber}`,
                class: "social-link"
              }, [
                _createVNode(_unref(PhoneIcon), { size: "1x" })
              ], 8, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (isUserAdminRef.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `${userRef.value?.pageUrl}/account`,
              class: "btn btn-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" View account ")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (!isUserAdminRef.value && isUserProfileVisibleRef.value && userProfileGroupRef.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: userProfileGroupRef.value.pageUrl,
              class: "btn btn-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" View tree profile ")
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (showImpersonateRef.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-warning btn-sm",
              onClick: impersonate
            }, " Impersonate "))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_16,
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("section", _hoisted_18, [
        _createVNode(UserProfileContent, { "user-id": userIdRef.value }, null, 8, ["user-id"])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _createVNode(ResearchGroupList, {
          "user-id": userIdRef.value,
          "for-user-profile": ""
        }, null, 8, ["user-id"])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createVNode(FamilyGroupList, {
          "user-id": userIdRef.value,
          "for-user-profile": ""
        }, null, 8, ["user-id"])
      ])
    ])
  ]))
}
}

})